// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Components
import BlogPostRelatedPosts from '../../blog/blogPostRelatedPosts/blogPostRelatedPosts';

export default function RelatedPosts({ layout }) {
  const posts = layout?.posts;
  const heading = layout?.heading;
  const bgColor = layout?.backgroundColour;

  return (
    <BlogPostRelatedPosts
      relatedPosts={posts}
      heading={heading}
      bgColor={bgColor}
      flexibleContent
    />
  );
}

RelatedPosts.propTypes = {
  layout: PropTypes.shape({
    posts: PropTypes.arrayOf(),
    heading: PropTypes.string,
    backgroundColour: PropTypes.string,
  }),
};

RelatedPosts.defaultProps = {
  layout: {},
};
